// @ts-strict-ignore
import {Component, ElementRef, Input, ViewChild} from "@angular/core";
import {FormControl} from "@angular/forms";
import {zoomInOnEnterAnimation, zoomOutOnLeaveAnimation} from "angular-animations";
import {Translations} from "@translations";
import {UntilDestroy} from "@ngneat/until-destroy";

@UntilDestroy()
@Component({
	selector: "sim-assessment-point-input",
	template: `
		@if (inEditMode) {
			<div [@zoomInOnEnter]>
				<mat-form-field class="itemEdit" color="accent" [ngStyle]="{width: customWidth}">
					<mat-label>{{ label }}</mat-label>
					<input
						type="number"
						matInput
						#pointInputRef
						[placeholder]="placeholder"
						[formControl]="pointControl"
						(focus)="handleFocus()"
					/>
					@if (pointControl.hasError("required") || pointControl.hasError("invalidNumber")) {
						<mat-error>{{ T.SHARED_POINT_INPUT_REQUIRED | translate }} </mat-error>
					}
					@if (pointControl.hasError("min")) {
						<mat-error>{{ T.SHARED_POINT_INPUT_NOT_NEGATIVE | translate }}</mat-error>
					}
					@if (pointControl.hasError("max")) {
						<mat-error
							>{{ T.SHARED_POINT_INPUT_GREATER_THAN | translate: {value: pointControl.getError("max").max} }}
						</mat-error>
					}
				</mat-form-field>
			</div>
		}
		@if (!inEditMode) {
			<sim-item-score small [isKnockout]="false" [dimmed]="!isActiveScore" [score]="pointControl.value" />
		}
	`,
	styleUrls: ["./assessment-point-input.component.scss"],
	animations: [zoomInOnEnterAnimation({duration: 300}), zoomOutOnLeaveAnimation({duration: 300})],
	standalone: false,
})
export class AssessmentPointInputComponent {
	T = Translations;

	@Input() label: string;
	@Input() customWidth: string;
	@Input() placeholder: string;
	@Input() inEditMode: boolean = false;
	@Input() isActiveScore: boolean = false;

	@Input({required: true}) pointControl: FormControl<number>;
	@ViewChild("pointInputRef") pointInputRef: ElementRef<HTMLInputElement>;

	handleFocus() {
		this.pointInputRef.nativeElement.select();
	}
}
